import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3252fee8")

_pushScopeId("data-v-3252fee8")
const _hoisted_1 = { class: "bg-ff" }
const _hoisted_2 = { class: "label text-center" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.showData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.id,
            label: item.name,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      title: "设置表单",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: '1000px'
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: ["flex alignC form", { 'bg-f2': index % 2 == 0 }],
            key: item.id
          }, [
            _createVNode("div", _hoisted_2, _toDisplayString(item.setitem_name), 1),
            _createVNode("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.list, (checkbox, indexs) => {
                return (_openBlock(), _createBlock(_component_el_checkbox, {
                  class: "checkbox",
                  key: checkbox.basicset_id,
                  "true-label": 1,
                  "false-label": 0,
                  "model-value": _ctx.form[item.setitem_id].value[indexs],
                  onChange: ($event: any) => (
                            _ctx.checkboxChange(
                                _ctx.form[item.setitem_id].value[indexs],
                                item.setitem_id,
                                indexs,
                                checkbox.basicset_id
                            )
                        )
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(checkbox.name), 1)
                  ]),
                  _: 2
                }, 1032, ["model-value", "onChange"]))
              }), 128))
            ])
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})